export const NETWORKS = [
  {
    key: 'facebook',
    name: 'Facebook',
  },
  {
    key: 'messenger',
    name: 'Facebook Messenger',
  },
  {
    key: 'whatsapp',
    name: 'WhatsApp',
  },
  {
    key: 'twitter',
    name: 'Twitter',
  },
  {
    key: 'pinterest',
    name: 'Pinterest',
  },
]
